module.exports = __webpack_public_path__ + "img/solo.app@svg.9c2dc219.svg";